<script lang="ts">
	interface Props {
		className?: string;
	}

	let { className = 'w-12' }: Props = $props();
</script>

<div
	class="flex flex-none items-center justify-center {className} aspect-square overflow-hidden rounded-lg"
>
	<img
		src="/logo_white.png"
		alt="logo"
		data-testid="logo"
		class="h-max-full w-max-full transition-all"
	/>
</div>
